import { render, staticRenderFns } from "./CardDescription.vue?vue&type=template&id=1a346412&scoped=true&"
import script from "./CardDescription.vue?vue&type=script&lang=js&"
export * from "./CardDescription.vue?vue&type=script&lang=js&"
import style0 from "./CardDescription.vue?vue&type=style&index=0&id=1a346412&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a346412",
  null
  
)

export default component.exports